// extracted by mini-css-extract-plugin
export default {"wrapper":"Panel_wrapper__WwtEQ","slideIn":"Panel_slideIn__r9Apa"};